import React from 'react';

import {
	CloseBtnNot,
	NotificationContentWrapper,
	NotificationWrapper
} from "./StyleNotification";

import Ok from "./Vector.png";
import close from "./VectorClose.png";
const NotificationContentOk = (props) => {

	const setClose = props.setClose;
	return (
		<NotificationWrapper>
		<NotificationContentWrapper>
			<CloseBtnNot onClick={setClose}>
				<img src={close} alt={close}/>
			</CloseBtnNot>
			<div>
				<img src={Ok}/>
			</div>
			<div>
				<h3>{props.h3}</h3>
				<p>{props.p}</p>
			</div>
		</NotificationContentWrapper>
		</NotificationWrapper>
	);
};

export default NotificationContentOk;